// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__2NE9i","tab":"ProcedureTabs_tab__2CMfT"};